import dagre from 'dagre';
import { Position } from 'reactflow';

const DEFAULT_NODE_WIDTH = 320;
const DEFAULT_NODE_HEIGHT = 220;

export const layoutGraph = (nodes, edges, { direction = 'LR' } = {}) => {
  const g = new dagre.graphlib.Graph();
  g.setDefaultEdgeLabel(() => ({}));
  g.setGraph({
    rankdir: direction,
    nodesep: 96,
    ranksep: 140,
  });

  nodes.forEach((node) => {
    g.setNode(node.id, {
      width: node.width || DEFAULT_NODE_WIDTH,
      height: node.height || DEFAULT_NODE_HEIGHT,
    });
  });

  edges.forEach((edge) => {
    g.setEdge(edge.source, edge.target);
  });

  dagre.layout(g);

  const isHorizontal = direction === 'LR' || direction === 'RL';

  const layoutedNodes = nodes.map((node) => {
    const { x, y } = g.node(node.id);
    const width = node.width || DEFAULT_NODE_WIDTH;
    const height = node.height || DEFAULT_NODE_HEIGHT;

    return {
      ...node,
      targetPosition: isHorizontal ? Position.Left : Position.Top,
      sourcePosition: isHorizontal ? Position.Right : Position.Bottom,
      position: {
        x: x - width / 2,
        y: y - height / 2,
      },
    };
  });

  return { nodes: layoutedNodes, edges };
};
